import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    showUserMenu: false,
    // HORO-10326: desktop sidebar collapsed flag. Default false = expanded
    // (190px, full menu w/ labels). When true, sidebar narrows to ~70px
    // showing icon-only rows per Figma 928:36258. Toggled by the top-bar
    // hamburger on desktop; mobile uses `showUserMenu` for drawer state.
    // Auto-collapsed on viewports narrower than 1280px so the chat column
    // isn't squeezed on mid-range desktops.
    sidebarCollapsed: typeof window !== 'undefined' ? window.innerWidth < 1280 : false
};

export const getUserMenuState = (state) => state.global.showUserMenu;
export const getSidebarCollapsed = (state) => state.global.sidebarCollapsed;

const globalSlice = createSlice({
    name: 'global',
    initialState,
    reducers: {
        toggleUserMenu(state, { payload }) {
            state.showUserMenu = payload;
        },
        toggleSidebarCollapsed(state, { payload }) {
            state.sidebarCollapsed = typeof payload === 'boolean' ? payload : !state.sidebarCollapsed;
        }
    }
});

export const globalReducer = globalSlice.reducer;

export const { toggleUserMenu, toggleSidebarCollapsed } = globalSlice.actions;
